module.exports = __webpack_public_path__ + "577b0e95e9c1483bb3aa850b97f72bcb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/1919_funds.png
// module id = 1783
// module chunks = 0